import { useState , useEffect} from "react";
import { useNavigate } from "react-router-dom";
import ListLayout from "../../../components/common/List/List-Layout";
import Convertdate from "../../../components/common/List/Converdate";
import ConfirmationModal from "../../../components/common/List/DeletePopup";
import { useDeleteBranchMutation, useGetBranchListallQuery } from "../../../store/api/branch";

const List = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [sortKey, setSortKey] = useState('created_at');
  const [pageSize, setPageSize] = useState(10);
  const [filterValues, setFilterValues] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState({});
  const [deleteBranch] = useDeleteBranchMutation();
  const { data: tabledata, isLoading, refetch } = useGetBranchListallQuery({
    page: currentPage,
    page_size: pageSize,
    sort: sortKey,
    ...filterValues,
  });


  const handleDelete = async () => {
    try {
      await deleteBranch(deleteid.id);
      setIsModalOpen(false);
      refetch()
    } catch (error) {
      console.error("Delete failed", error);
      refetch();
    }
  };

  const handleSort = () => {};

  const tableHeaders = [
    { label: "S.NO", key: "serial_no", increameant: true, placeholder: "S.NO" },
    { label: "Branch Name", key: "branch_name", sortable: false },
    { label: "Created Date", key: "created_at", formatter: Convertdate, sortable: false },
  ];


  useEffect(() => {
    refetch()
  },[])
  const filters = [];

  const filterComponents = filters.map((filter) => ({
    ...filter,
    value: filterValues[filter.key] || "",
  }));

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
  };

  const actionButtons = [
    // {
    //   icon: "MdOutlineRemoveRedEye",
    //   onClick: (row) => navigate("/view-branch", { state: { data: row,pageName: "Branch" } }),
    // },
    {
      icon: "MdOutlineModeEdit",
      onClick: (row) => {
        navigate("/edit-branch", { state: { data: row, pageName: " Branch" } });
      },
    }
,    
    
    {
      icon: "RiDeleteBinLine",
      onClick: (row) => {
        setdeleteid(row);
        setIsModalOpen(true);
      },
    },
  ];

  

  const Buttons = [
    {
      title: "+ Add Branch",
      
      design:
        "px-2 text-base py-1.5 bg-secondary font-normal text-white rounded hover:bg-secondary-700 flex items-center gap-1",
      onClick: () =>
        navigate("/create-branch", { state: { pageName: "Branch" } }),
    },
  ];

  return (
      <>
        <ListLayout
        permissionname="branch"
          title="Branch List"
          Buttons={Buttons}
          filterComponents={filterComponents}
          onFilterChange={handleFilterChange}
          tableHeaders={tableHeaders}
          tabledata={tabledata?.branches || []}
          actionButtons={actionButtons}
          currentPage={currentPage}
          totalrecords={tabledata?.count}
          setCurrentPage={setCurrentPage}       
          onSort={handleSort}
          sortKey={sortKey}
          isLoading={isLoading}
        />


        {isModalOpen && (
          <ConfirmationModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={handleDelete}
          />
        )}
      </>
  );
};

export default List;
